<script>
    import { onMount, createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    export let display = "none";
    let paises = [];
    let xpaises = [];
    let buscado = "";

    $: {
        xpaises = paises.filter((p) => {
            return p.nombre.toUpperCase().includes(buscado.toUpperCase());
        });
        xpaises = [...xpaises];
    }

    onMount(async () => {
        try {
            const body = new FormData();
            body.append("accion", "consulta");
            const res = await fetch("api/paises.php", {
                method: "POST",
                body,
            });

            if (res.ok) {
                let json = await res.json();
                if (json.error) {
                    console.log(json.mensaje);
                } else {
                    paises = [...json.datos];
                }
            }
        } catch (error) {
            console.log(error);
        }
    });

    function elige(f){
        dispatch('elegido', f);
    }
</script>

<div class="w3-modal" style="display:{display}">
    <div class="w3-modal-content w3-animatetop w3-round w3-white">
        <div class="w3-container">
            <div class="w3-section">
                <div class="w3-display-container" style="height:45px">
                    <div class="w3-display-left">
                        <h3>Lista de Paises</h3>
                    </div>
                    <button
                        class="w3-display-right w3-btn w3-red"
                        on:click={() => dispatch("cerrar")}>X</button
                    >
                </div>
            </div>
            <div class="w3-section">
                <input
                    type="text"
                    class="w3-input w3-round w3-light-grey"
                    bind:value={buscado}
                    placeholder="Buscar..."
                />
            </div>
            <div class="w3-section">
                <div class="w3-responsive">
                    <table class="w3-table-all w3-hoverable">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Nombre</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each xpaises as p}
                                <tr style='cursor:pointer' on:click={elige(p)}>
                                    <td>{p.iso}</td>
                                    <td>{p.nombre}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
